import React, {FC, useEffect, useState} from 'react'
import {ApiService} from '../Services'
import {CustomerDTO} from '../Models/ApiModels'
import {ApiURL} from '../AppConstants'
import {Box} from '@material-ui/core'
import {Option, Select} from './Select'
import {ValueType} from 'react-select'
import { LNG } from '../Services/LanguageService';

type CustomerPickerProps = {
    customerValue: string
    onChange(customerId: string): void
}

export const CustomerPicker: FC<CustomerPickerProps> = ({onChange, customerValue}) => {
    const [customers, setCustomers] = useState<CustomerDTO[]>([])
    useEffect(() => {
        async function getCustomers() {
            const resp = await ApiService.getLoopData<CustomerDTO>(ApiURL.Customer)
            setCustomers(resp)
        }

        void getCustomers()
    }, [onChange])

    const _options = customers.map(c => {
        return {
            value: c.id,
            label: c.name,
        }
    }).sort((s1, s2) => (s1.label > s2.label) ? 1 : ((s2.label > s1.label) ? -1 : 0))

    const _onCompanyChange = (selected: ValueType<Option, false>) => {
        if (selected) {
            onChange(selected.value)
        }
    }

    if (!customers.length || customers.length === 1) return null
    return (
        <Box width={250} mb={1}>
            <Select
                label={LNG.Text('Dashboard.17')}
                value={_options.find(e => e.value === customerValue)}
                options={_options}
                onChange={_onCompanyChange}/>
        </Box>
    )
}